import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Floating back/forward navigation arrows.
 * Uses React Router history (browser history) — navigates through the SPA stack.
 */
export const NavArrows = ({ className = '' }) => {
  const navigate = useNavigate();
  const canGoBack = typeof window !== 'undefined' && window.history.length > 1;

  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="nav-arrows">
      <Button
        onClick={() => navigate(-1)}
        size="icon"
        variant="outline"
        disabled={!canGoBack}
        className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:border-[#00F0FF] hover:text-[#00F0FF] rounded-none h-9 w-9 disabled:opacity-30 disabled:cursor-not-allowed"
        data-testid="nav-arrow-back"
        aria-label="Voltar"
        title="Voltar"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Button
        onClick={() => navigate(1)}
        size="icon"
        variant="outline"
        className="bg-transparent border-white/20 text-white hover:bg-white/10 hover:border-[#00F0FF] hover:text-[#00F0FF] rounded-none h-9 w-9"
        data-testid="nav-arrow-forward"
        aria-label="Avançar"
        title="Avançar"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default NavArrows;
